import { columnHelper } from './index'
import { Checkbox } from '../Checkbox/index'
import { Radio } from '../Radio/index'

/**
 * 配列から特定の値を持つObjectを探し、指定されたキーの値を返却
 * @param {Array<object>} dataList
 * @param {string} findKey
 * @param {string | number} findValue
 * @param {string} specifiedKey
 * @returns {string | number}
 */
export const getValueOfSpecifiedKey = (dataList, findKey, findValue, specifiedKey) => {
    const findObject = dataList.find((data) => {
        return data[findKey] === findValue
    })
    return findObject[specifiedKey]
}

/**
 * カラム定義にNoの表示を追加
 * @param {string} rowNumberColumnName
 * @param {Array<object>} columns
 * @returns {Array<object>}
 */
export const addNoColumn = (rowNumberColumnName, columns) => {
    return [
        columnHelper.display({
            header: rowNumberColumnName,
            id: 'no',
            cell: ({ row, table }) =>
                (table.getSortedRowModel()?.flatRows?.findIndex((flatRow) => flatRow.id === row.id) || 0) + 1,
            size: 60
        }),
        ...columns
    ]
}

/**
 * カラム定義にチェックボックスの表示を追加
 * isAllCheckがtrueの場合は全選択のチェックボックスを表示
 * @param {Array<object>} data
 * @param {Array<object>} columns
 * @param {string} selectedId
 * @param {Array<string | number>} selectedData
 * @param {boolean} isAllCheck
 * @param {boolean} isAll
 * @param {func} onClickSelectBox
 * @param {func} handleChangeAllCheckbox
 * @param {Array<string | number>} disabledCheckboxList
 * @returns {Array<object>}
 */
export const addCheckboxColumn = (
    data,
    columns,
    selectedId,
    selectedData,
    isAllCheck,
    isAll,
    onClickSelectBox,
    handleChangeAllCheckbox,
    disabledCheckboxList
) => {
    const isDisabledAllCheck = !data.length || data.length === disabledCheckboxList?.length
    return [
        columnHelper.display({
            header: () => {
                return isAllCheck ? (
                    <Checkbox
                        name="tableCheckbox"
                        checked={isAll}
                        onChange={handleChangeAllCheckbox}
                        disabled={isDisabledAllCheck}
                    />
                ) : (
                    <></>
                )
            },
            id: 'checkbox',
            size: 48,
            cell: ({ row }) => {
                const original = row.original[selectedId]
                const isDisabledCheck = disabledCheckboxList && disabledCheckboxList.includes(original)
                const checked = !isDisabledCheck && selectedData?.includes(original)
                return (
                    <Checkbox
                        name="tableCheckbox"
                        checked={checked}
                        value={original}
                        onChange={(_value, e) => onClickSelectBox(original, e)}
                        disabled={isDisabledCheck}
                    />
                )
            }
        }),
        ...columns
    ]
}

/**
 * カラム定義にラジオの表示を追加
 * @param {Array<object>} columns
 * @param {string} selectedId
 * @param {Array<string | number>} selectedData
 * @param {func} onClickSelectBox
 * @returns {Array<object>}
 */
export const addRadioColumn = (columns, selectedId, selectedData, onClickSelectBox) => {
    return [
        columnHelper.display({
            id: 'radio',
            size: 48,
            cell: ({ row }) => {
                const original = row.original[selectedId]
                const itemList = [
                    {
                        value: original
                    }
                ]
                return <Radio itemList={itemList} name="tableRadio" value={selectedData} onChange={onClickSelectBox} />
            }
        }),
        ...columns
    ]
}
